import React from 'react';
import { Eye } from 'lucide-react';

const VisionStatement = () => {
    return (
        <section
            className="bg-purple-50 py-16 px-6 border rounded-lg shadow-lg max-w-4xl mx-auto mb-12"
            data-aos="fade-up"
        >
            <div className="text-center mb-6">
                <h4 className="text-2xl md:text-3xl font-bold text-purple-800 flex justify-center items-center gap-2">
                    <Eye className="w-6 h-6 text-purple-600" />
                    Our Vision
                </h4>
                <hr className="w-20 border-t-2 border-purple-400 mx-auto mt-2" />
            </div>

            <p className="text-gray-800 text-lg leading-relaxed text-center max-w-2xl mx-auto" data-aos="fade-up" data-aos-delay="200">
                <strong>Ibadan South Diocese (Anglican Communion)</strong> shall be <span className="text-purple-700 font-medium">Bible-Based, God-centered, Holy Spirit-Guided</span>, committed to <span className="text-purple-700 font-medium">pragmatic evangelism</span> and preparing men and women to <span className="text-purple-700 font-medium">joyfully meet our Lord Jesus Christ</span> at His second coming.
            </p>
        </section>
    );
};

export default VisionStatement;
